import React from 'react';

import {IconoirWarningCircle} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

import Tooltip from '../../../../../CoreWrappers/Tooltip';
import StackedBarChart from '../../../../Charts/StackedBarChart';

export const config = ({
	id,
	fullId = null,
	label,
	prop,
	width = 'minmax(var(--px-200), 3fr)',
	getSeries = () => [],
	tooltipFormatter = null,
	customHeaderTooltip = null
}) => {
	const configObj = {
		id: fullId ? fullId : `${id}BarchartColumn`,
		label,
		propName: prop,
		width,
		customCell: (item) => {
			const props = {series: getSeries(item)};
			if (tooltipFormatter)
				props.tooltipFormatter = (numberFormat, series) => tooltipFormatter(item, numberFormat, series);

			return <StackedBarChart {...props} />;
		}
	};

	if (customHeaderTooltip)
		configObj.customHeaderCell = (item) => {
			const renderTrigger = () => <Icon src={IconoirWarningCircle} />;

			const props = {
				trigger: renderTrigger(),
				tooltipText: customHeaderTooltip,
				placement: 'top'
			};

			return (
				<>
					<OutputText body2 title={label} ellipsis>
						{label}
					</OutputText>
					<Tooltip {...props} />
				</>
			);
		};

	return configObj;
};
